module.exports = __webpack_public_path__ + "static/media/the-lab1.7ce4d1bc.jpg";